import { render } from "./SpinnerModal.vue?vue&type=template&id=66a0be5c&scoped=true"
import script from "./SpinnerModal.vue?vue&type=script&lang=js"
export * from "./SpinnerModal.vue?vue&type=script&lang=js"

import "./SpinnerModal.vue?vue&type=style&index=0&id=66a0be5c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a0be5c"]])

export default __exports__